// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取店铺平台列表
export function store_Platform(params) {
  return request({
    url: "/api/sale_auth/store_platform_list",
    method: "get",
    params,
  });
}

// 获取发送验证码
export function sendPhonCode(data) {
  return request({
    url: "/api/sale_auth/phone_send_code",
    method: "post",
    data,
  });
}

// 获取发送验证码
export function certPhonCode(data) {
  return request({
    url: "/api/sale_auth/cert_phone_code",
    method: "post",
    data,
  });
}



// 销售授权申请
export function certificationSubmit(data) {
  return request({
    url: "/api/sale_auth/certification_submit",
    method: "post",
    data,
  });
}

// 获取协议
export function getAgreement(params) {
  return request({
    url: "/api/sale_auth/get_agreement",
    method: "get",
    params,
  });
}




